import React, {useEffect, useState} from "react";
import {useRouter} from "next/router";
import {FormattedMessage} from "react-intl";
import {domainUrl} from "../../helper";
import Head from "next/head";
import {MetaWrapper} from "../MetaWrapper";
import dynamic from 'next/dynamic'
import {IState} from "../../types/state";
import {useSelector} from "react-redux";

const PageHeader = dynamic(() => import('../shared/PageHeader'))
const Content = dynamic(() => import('./Content'))

function SiteCustomPage(props: any) {
    const {pageSlug, domain, dbName} = props;
    const [content, setContent] = useState(props?.content);
    const [isTable, setIsTable] = useState(false)
    const router = useRouter();

    useEffect(() => {
        if (pageSlug) {
            setContent(props?.content);
        }
    }, [pageSlug, router.locale]);

    useEffect(() => {
        if (content) {
            let text = document.getElementsByTagName('table')
            text && text[0] ? setIsTable(true) : setIsTable(false)
        }
    }, [])
    const schemaPages = {
        "@context": `https://schema.org/`,
        "@type": "Page",
        name: "Pages",
        offers: [],
        url: domainUrl(dbName + router.asPath),
    };
    const breadcrumb = [
        {
            title: <FormattedMessage id="home" defaultMessage="Home"/>,
            url: `https://${dbName}/`
        },
        {
            title: content?.data[0]?.page_title,
            url: ""
        }
    ];

    const logoPath = `/stores-logo.svg`
    const metaData = content?.data[0]

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{__html: JSON.stringify(schemaPages)}}
                />
            </Head>
            <div>
                <PageHeader header={breadcrumb[1].title} breadcrumb={breadcrumb}/>

                <Content text={content} {...props} isTable={isTable} domain={props.domain} dbName={props.dbName}/>
            </div>
        </>

    );
}

export default SiteCustomPage;
